import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardingRootComponent } from './onboarding-root/onboarding-root.component';
import { RouterModule } from '@angular/router';
import { onboardingRoutes } from './onboarding.routes';
import { LayoutModule } from '../shared/layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { OnboardingWelcomeComponent } from './onboarding-welcome/onboarding-welcome.component';
import { ChannelsFeatureComponent } from './channels-feature/channels-feature.component';
import { StartActionsComponent } from './start-actions/start-actions.component';
import { SharedModule } from '../shared/shared.module';
import { WidgetModule } from '../widget/widget.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(onboardingRoutes),
    LayoutModule,
    TranslateModule,
    SharedModule,
    WidgetModule
  ],
  declarations: [OnboardingRootComponent, OnboardingWelcomeComponent, ChannelsFeatureComponent, StartActionsComponent]
})
export class OnboardingModule {}
